(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class MobileDisclosure extends DetailsDisclosure {
      constructor() {
        super();

        const collapseEnabled = this.dataset.collapse === 'true';
        if (!collapseEnabled) return;

        this.reset();
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
          this.querySelectorAll('.disclosure, .disclosure__title, .disclosure__panel, .disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(`mobile-${cl}`);
            });
          });
        } else {
          this.toggle.removeAttribute('tabindex');
          this.querySelectorAll('.mobile-disclosure, .mobile-disclosure__title, .mobile-disclosure__panel, .mobile-disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('mobile-disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(cl.substr(7));
            });
          });
        }
      }
    }

    customElements.define('mobile-disclosure', MobileDisclosure);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
(() => {
  function init(scope, immediate) {
    scope.querySelectorAll('.related-products').forEach(section => {
      if (section.recommendationsReady) return;
      section.recommendationsReady = true;
      let observer;
      let request;
      const load = () => {
        if (request) return;
        if (observer) observer.disconnect();
        request = new AbortController();
        section.recommendationsRequest = request;
        fetch(section.dataset.url, { signal: request.signal })
          .then(response => { if (!response.ok) throw new Error('Recommendations unavailable'); return response.text(); })
          .then(html => {
            if (!section.isConnected || request.signal.aborted) return;
            const template = document.createElement('template');
            template.innerHTML = html;
            const result = template.content.querySelector('.related-products');
            if (result) section.innerHTML = result.innerHTML;
          })
          .catch(() => { /* Keep the section empty if recommendations are unavailable. */ });
      };
      if (immediate || !('IntersectionObserver' in window)) load();
      else {
        observer = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) load();
        }, { rootMargin: '600px 0px' });
        section.recommendationsObserver = observer;
        observer.observe(section);
      }
    });
  }
  init(document, !!window.Shopify?.designMode);
  document.addEventListener('shopify:section:load', event => init(event.target.parentNode, true));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('.related-products').forEach(section => {
      section.recommendationsObserver?.disconnect();
      section.recommendationsRequest?.abort();
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
